export const DIGI_SUBS_PRICE_VALUE = 69;

export const subsURL = {
  ALL_SUBS_URL: "https://muj.reportermagazin.cz/subscriptions",
  GIFT_SUBS_URL: "https://muj.reportermagazin.cz/subscriptions#jako-darek",
};
